import { useState } from "react";
import { Alert, Button, Card, Typography } from "antd";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRedirectRequest } from "../authConfig";

const { Title, Paragraph, Text } = Typography;

const SignIn = () => {
  const { instance, inProgress } = useMsal();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const isAuthenticated = useIsAuthenticated();

  const handleSignIn = async () => {
    if (isAuthenticated) {
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      // A full-page redirect avoids the new-tab popup flow, which is unreliable on iOS
      // Safari: it can leave the tab stuck on about:blank until a retry (SIG-87).
      await instance.loginRedirect({
        ...loginRedirectRequest,
        prompt: "select_account",
      });
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "Sign-in failed. Please try again.";
      if (errorMessage.includes("interaction_in_progress")) {
        return;
      }
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const showSpinner =
    isLoading || inProgress !== InteractionStatus.None;

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <Title level={3}>Sign in to Scanner</Title>
        <Paragraph>
          Use your Microsoft Entra ID account to access the scanner
          application.
        </Paragraph>
        <Paragraph>
          <Text type="secondary">
            You may be prompted to select or confirm the account that was
            provided for this environment.
          </Text>
        </Paragraph>
        <Button
          type="primary"
          size="large"
          block
          onClick={handleSignIn}
          loading={showSpinner}
        >
          Sign in with Microsoft
        </Button>
        {error ? (
          <Alert
            type="error"
            showIcon
            message="Unable to sign in"
            description={error}
            className="login-error"
          />
        ) : null}
      </Card>
    </div>
  );
};

export default SignIn;
